import React, { useMemo, useCallback, memo } from 'react';
import { useQuery } from '@apollo/react-hooks';

import { GET_PROGRAM_ADVANCE } from '../../graphql/queries';
import {
  GetProgramsAdvance,
  GetProgramsAdvanceVariables,
} from '../../generated/GetProgramsAdvance';

import Dropdown, { Props as DropdownProps } from './Dropdown';

const defaultTitle = t(['Pilih Program', 'Select Program']);

type Props = Omit<DropdownProps, 'options' | 'title'> & {
  title?: string;
};

const StoreAchievementDropdown = memo((props: Props) => {
  let { title = defaultTitle, selectedOption, ...otherProps } = props;

  const { data, loading, error, refetch } = useQuery<
    GetProgramsAdvance,
    GetProgramsAdvanceVariables
  >(GET_PROGRAM_ADVANCE, {
    variables: {
      where: {},
    },
    notifyOnNetworkStatusChange: true,
  });

  const refetchData = useCallback(() => {
    const asyncRefetch = async () => {
      try {
        await refetch();
      } catch (_) {
        // NOTE: error because of token handled by AuthContext
      }
    };
    asyncRefetch();
  }, [refetch]);

  const options = useMemo(
    () =>
      /* For now only show E-Wallet */
      data?.getProgramsAdvance.map(({ id, name }) => ({
        label: name,
        value: id.toString(),
      })) ?? [],
    [data],
  );

  return (
    <Dropdown
      error={error}
      errorAction={t([
        'mengambil data program advance',
        'retrieve the program advance data',
      ])}
      onRetryPress={refetchData}
      options={options}
      title={title}
      loading={loading}
      selectedOption={selectedOption}
      {...otherProps}
    />
  );
});

export default StoreAchievementDropdown;
